const scheduledServicesServicesForSchedulingFilterModal = {
  "filter": "FILTERS",
  "clear": "Clear Filters",
  "site": "Sites",
  "groups": "Group",
  "place": "Places",
  "area": "Departments",
  "company": "Third-Party Company",
  "equipmentModel": "Equipment Type",
  "frequencies": "Frequencies",
  "serviceTypes": "Service Types",
  "cancel": "CANCEL",
  "ok": "APPLY",
  expirationDate: "Expiration Date:",
  equipments: 'Equipments',
  noService: 'Services not performed',
  valid: 'Services up-to-date',
  overdue: 'Overdue services',
  validHelperText: 'Shows services that are not overdue yet (includes on-demand services)',
  overdueHelperText: 'Shows services that are already overdue',
  expirationDateHelperText: 'For up-to-date and overdue services, does not affect services not performed',
};

export default scheduledServicesServicesForSchedulingFilterModal;